import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import flattenSequentially from 'xstream/extra/flattenSequentially';
import * as actions from '../actions';
import { history } from '../store/store';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const POST_CLAIM_APPLICATION = 'postClaimApplication';
const UPDATE_CLAIM_APPLICATION = 'updateClaimApplication';
const POST_DRAFT_CLAIM_APPLICATION = 'postDraftClaimApplication';
const REQUEST_CLAIM_APPLICATION_BY_ID = 'requestClaimApplicationById';
const REQUEST_CLAIM_APPLICATIONS = 'requestClaimApplications';
const FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS =
    'fetchClaimApplicationBankAccountAnswers';
const UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT =
    'updateClaimApplicationBankAccount';
const POST_WITHDRAWN_CLAIM_APPLICATION = 'postWithdrawnClaimApplication';
const FETCH_CLAIM_APPLICATION_TEMPLATE = 'fetchClaimApplicationTemplate';
const FETCH_CUSTOMER_FEEDBACK_AFTER_SUCCESS_CLAIM =
    'fetchCustomerFeedbackAfterSuccessClaim';

export function fetchClaimApplicationAfterMakingClaimBankAccount(sources) {
    const action$ = sources.ACTION.filter(action => {
        return (
            action.type ===
            ActionTypes.UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT_SUCCESS
        );
    }).map(action => {
        return actions.fetchClaimApplicationById(
            action.payload.body.data.claimApplicationId,
        );
    });

    return {
        ACTION: action$,
    };
}

export function fetchCustomerFeedbackAfterSuccessClaim(sources) {
    const action$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.SEND_CLAIM_APPLICATION_SUCCESS;
    }).map(action => {
        return actions.fetchApplicationCustomerFeedback();
    });
    return {
        ACTION: action$,
    };
}

export function fetchClaimApplicationBankAccountAnswers(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/ClaimApplicationBankAccount/ClaimApplication/${action.payload.claimApplicationId}/Answers`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        FETCH_CLAIM_APPLICATION_BANK_ACCOUNT_ANSWERS,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimApplicationBankAccountAnswersSuccess(
                      response,
                  )
                : actions.fetchClaimApplicationBankAccountAnswersFailed(
                      response,
                  ),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function updateClaimApplicationBankAccount(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/ClaimApplicationBankAccount`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT,
            method: 'PUT',
            send: action.payload,
        }));

    let httpResponse$ = sources.HTTP.select(
        UPDATE_CLAIM_APPLICATION_BANK_ACCOUNT,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.updateClaimApplicationBankAccountSuccess(response)
                : actions.updateClaimApplicationBankAccountFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function redirectAfterClaimSubmit(sources) {
    const action$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.SEND_CLAIM_APPLICATION_SUCCESS ||
            action.type === ActionTypes.UPDATE_CLAIM_APPLICATION_SUCCESS,
    ).map(action => {
        history.push(`/claim/${action.payload.body.data}/submitted`);
        return actions.redirectAfterClaimSubmit(action.payload.body.data);
    });

    return {
        ACTION: action$,
    };
}

export function postClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.SEND_CLAIM_APPLICATION,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/claimApplication',
            category: POST_CLAIM_APPLICATION,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'POST',
            send: action.payload.data,
        }));

    let httpResponse$ = sources.HTTP.select(POST_CLAIM_APPLICATION)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.sendClaimApplicationSuccess(response)
                : actions.sendClaimApplicationFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function updateClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.UPDATE_CLAIM_APPLICATION,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/claimApplication/${action.payload.data.ClaimApplicationId}`,
            category: UPDATE_CLAIM_APPLICATION,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'PUT',
            send: action.payload.data,
        }));

    let httpResponse$ = sources.HTTP.select(UPDATE_CLAIM_APPLICATION)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.updateClaimApplicationSuccess(response)
                : actions.updateClaimApplicationFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.GET_CLAIM_APPLICATION_BY_ID,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/claimApplication/${action.payload}/claimant`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_APPLICATION_BY_ID,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_APPLICATION_BY_ID)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimApplicationByIdSuccess(response)
                : actions.fetchClaimApplicationByIdFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function postDraftClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.SEND_DRAFT_CLAIM_APPLICATION_BY_USER,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/DraftClaimApplication',
            category: POST_DRAFT_CLAIM_APPLICATION,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'POST',
            send: action.payload.data,
        }));

    let httpResponse$ = sources.HTTP.select(POST_DRAFT_CLAIM_APPLICATION)
        .map(response => response.replaceError(err => xs.of(err)))
        .compose(flattenSequentially)
        .map(response =>
            response.status === 200
                ? actions.sendDraftClaimApplicationByUserSuccess(response)
                : actions.sendDraftClaimApplicationByUserFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestClaimApplications(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.GET_CLAIM_APPLICATIONS,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/claimApplication?page=${action.payload.page ? action.payload.page : 1}&limit=${action.payload.limit ? action.payload.limit : 20}`,
            category: REQUEST_CLAIM_APPLICATIONS,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_APPLICATIONS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimApplicationsSuccess(response)
                : actions.fetchClaimApplicationsFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function postWithdrawnClaimApplication(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.CREATE_WITHDRAWN_CLAIM_APPLICATION,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/ClaimTransition/${action.payload.claimApplicationId}/withdraw`,
            category: POST_WITHDRAWN_CLAIM_APPLICATION,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'POST',
            send: action.payload.data,
        }));

    let httpResponse$ = sources.HTTP.select(POST_WITHDRAWN_CLAIM_APPLICATION)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.createWithdrawnClaimApplicationSuccess(response)
                : actions.createWithdrawnClaimApplicationFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function fetchClaimApplicationTemplate(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_APPLICATION_TEMPLATE,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/ClaimApplicationTemplate/${action.payload.templateId}/ClaimApplication/${action.payload.claimApplicationId}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: FETCH_CLAIM_APPLICATION_TEMPLATE,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(FETCH_CLAIM_APPLICATION_TEMPLATE)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimApplicationTemplateSuccess(response)
                : actions.fetchClaimApplicationTemplateFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
